import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import HeadsetMicRoundedIcon from '@mui/icons-material/HeadsetMicRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { useNavigate } from 'react-router';
import '../Customer/CustomerScreens.scss';

const contactCards = [
  { icon: <PhoneRoundedIcon fontSize='small' />, title: 'Call us', value: '+91 98765 43210' },
  { icon: <EmailRoundedIcon fontSize='small' />, title: 'Email support', value: 'support@papad.com' },
  { icon: <LocationOnRoundedIcon fontSize='small' />, title: 'Office', value: 'Papad Foods, Chennai, India' },
];

export default function ContactUs() {
  const navigate = useNavigate();

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Contact Us</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 2.25 }}>
          <Stack direction='row' spacing={1.25} alignItems='center'>
            <Box className='customer-menuIcon'>
              <HeadsetMicRoundedIcon fontSize='small' />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700 }}>We are here to help</Typography>
              <Typography className='customer-muted'>
                Reach our support team for orders, refunds, delivery, or account help.
              </Typography>
            </Box>
          </Stack>
        </Paper>

        <Typography className='customer-sectionTitle'>Support channels</Typography>
        <Box className='customer-menuList'>
          {contactCards.map((item) => (
            <Paper key={item.title} className='customer-card' sx={{ p: 2 }}>
              <Box className='customer-menuLead'>
                <Box className='customer-menuIcon'>{item.icon}</Box>
                <Box>
                  <Typography sx={{ fontWeight: 700 }}>{item.title}</Typography>
                  <Typography className='customer-muted'>{item.value}</Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>

        <Typography className='customer-sectionTitle'>Send a message</Typography>
        <Paper className='customer-card' sx={{ p: 2.25 }}>
          <Stack className='customer-formGrid'>
            <TextField fullWidth label='Name' placeholder='Enter your name' />
            <TextField fullWidth label='Email' placeholder='name@email.com' />
            <TextField fullWidth label='Subject' placeholder='What do you need help with?' />
            <TextField fullWidth multiline minRows={4} label='Message' placeholder='Describe your issue or question' />
            <Button className='customer-actionButton customer-actionButton--primary'>
              Send message
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
